<!-- 用户管理--添加用户 -->
<template>
	<div class="container height-all">
		<div class="containerMain flex-shrink">
			<el-form ref="addUserformForm" :rules="userId == '' ? addUserformRules : editUserformRules" :model="addUserform">
				<div class="containerInfoItem">
					<el-form-item label="用户登录账号" prop="name" class="elFormItemBox">
						<el-input type="text" v-model="addUserform.name" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="登录密码" prop="password" class="elFormItemBox">
						<el-input type="password" v-model="addUserform.password" placeholder="请输入" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="passwordEnter" class="elFormItemBox">
						<el-input type="password" v-model="addUserform.passwordEnter" placeholder="请输入" maxlength="20"></el-input>
					</el-form-item>
					<!-- <el-form-item label="所属用户组" prop="groupName" class="elFormItemBox">
						<el-input type="text" v-model="addUserform.groupName" readonly placeholder="请输入" @click="selectUserGrounp"></el-input>
					</el-form-item> -->
					<el-form-item label="姓名" prop="realName" class="elFormItemBox">
						<el-input type="text" v-model="addUserform.realName" placeholder="请输入"></el-input>
					</el-form-item>
					<!-- <el-form-item label="昵称" prop="otherName" class="elFormItemBox">
						<el-input type="text" v-model="addUserform.otherName" placeholder="请输入"></el-input>
					</el-form-item> -->
<!--					<el-form-item label="企业名称" prop="companyChoose" class="elFormItemBox">-->
<!--						<el-autocomplete class="searchItemInput" style="width: 100%;" v-model="addUserform.companyChoose" value-key="label" :fetch-suggestions="querySearch"-->
<!--							data-valuekey="label" data-labelkey="id" placeholder="请输入公司名称" :trigger-on-focus="false" clearable @select="handleInputSelect($event)">-->
<!--						</el-autocomplete>-->
<!--					</el-form-item>-->
					
					<el-form-item label="手机号" prop="telPhone" class="elFormItemBox">
						<el-input type="text" v-model="addUserform.telPhone" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="性别" prop="sex" class="elFormItemBox">
						<el-select v-model="addUserform.sex" placeholder="请选择">
							<el-option v-for="item in sex" :key="item.value" :label="item.label" :value="item.value"/>
						</el-select>
					</el-form-item>
					<el-form-item label="岗位" prop="job" class="elFormItemBox">
						<el-select v-model="addUserform.job" placeholder="请选择">
							<el-option v-for="item in jobArr" :key="item.code" :label="item.name" :value="item.code"/>
						</el-select>
					</el-form-item>
					<el-form-item label="会员号" prop="platformOsUserMemberNum" class="elFormItemBox">
						<el-input type="text" v-model="addUserform.platformOsUserMemberNum" placeholder="请输入"></el-input>
					</el-form-item>
					<!-- <el-form-item label="微信号" prop="weChatId" class="elFormItemBox">
						<el-input type="text" v-model="addUserform.weChatId" placeholder="请输入"></el-input>
					</el-form-item> -->
					<el-form-item label="有效状态" prop="onWork" class="elFormItemBox">
						<el-select v-model="addUserform.onWork" placeholder="请选择">
							<el-option v-for="item in onWork" :key="item.value" :label="item.label" :value="item.value"/>
						</el-select>
					</el-form-item>
<!--					<el-form-item label="用户密钥" prop="secretKey" class="elFormItemBox">-->
<!--						<el-input type="text" v-model="addUserform.secretKey" readonly placeholder="请输入">-->
<!--							<template #append>-->
<!--								<span style="cursor: pointer;" @click="userKeyFun">自动生成</span>-->
<!--							</template>-->
<!--						</el-input>-->
<!--					</el-form-item>-->
				</div>
				<div class="containerInfoItem">
					<el-form-item label="用户头像" class="elFormItemBox">
						<el-upload
						  class="avatar-uploader"
						  action=""
						  :limit="1"
						  :show-file-list="false"
						  :http-request="uploadHeaderImgFile">
						  <img v-if="addUserform.headImageUrl" :src="addUserform.headImageUrl" class="avatar">
						  <i v-else class="avatar-uploader-icon"><Plus /></i>
						</el-upload>
					</el-form-item>
				</div>
				<div class="containerInfoItem" style="align-items: flex-start;">
					<!-- <el-form-item label="分配系统菜单" class="elFormItemBox" style="width: 50%;">
						<el-tree ref="systemMenu" :data="systemMenuList" show-checkbox node-key="key" :props="menuTreeProps" :default-checked-keys="addUserform.systemMenuList">
						</el-tree>
					</el-form-item> -->
					<el-form-item label="用户角色分配" class="elFormItemBox" style="width: 50%;">
						<el-checkbox-group v-model="addUserform.role">
							<el-checkbox v-for="(item,index) in roleList" :key="item.value" :label="item.value" :value="item.value">{{item.name}}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</div>
			</el-form>
			
			<!-- 确认选择按钮 -->
			<div class="footerEnterBtn flex align-center justify-center">
				<!-- <el-button @click="resetForm">&nbsp;&nbsp;重置&nbsp;&nbsp;</el-button> -->
				<el-button type="primary" @click="saveForm">&nbsp;&nbsp;确认&nbsp;&nbsp;</el-button>
			</div>
		</div>
		
		<!-- 选择用户组 -->
		<basedialog title="选择用户组" :dialogWidth="400" :dialogVisible="isShowUserGrounpTree" closeText="清除" @dialogConfirm="userGrounpTreeDialogConfirm" @dialogClose="userGrounpTreeDialogClear" @dialogRightTopClose="userGrounpTreeDialogClose">
			<template #dialogbody>
				<el-form label-width="100px" class="dialogForm">
					<el-form-item label="用户组:" class="flex align-start">
						<el-tree ref="dialogTree" :data="groupArr" :check-strictly="true" :props="{label: 'title', children: 'children'}"
						  node-key="key" :highlight-current="true">
						</el-tree>
					</el-form-item>
				</el-form>
			</template>
		</basedialog>
		
	</div>
</template>

<script>
	import basedialog from "@/components/basedialog"
	export default{
		inject: ['$http', '$api', '$utils', '$uploadFileUtils'],
		components:{
			basedialog,
		},
		data(){
			return{
				userId:'',
				addUserformRules:{
					"name": [{
						validator:(rule, value, callback) => {
							if (value === '') {
								callback(new Error('请输入登录名'));
							} else {
								this.$http.post(this.$api.userCheckNameApi,{name:value}).then(res=>{
									if(res.code == 200){
										if(res.data.id == 0){
											callback();
										}else{
											callback(new Error('当前账号名已被使用!'));
										}
									}
								})
							}
						},required: true, trigger: "blur"}],
					"password": [{validator:(rule, value, callback) => {
							if (value === '') {
								callback(new Error('请输入密码'));
							} else if (!this.$utils.paswordReg(value)) {
								console.log('value',value)
								callback(new Error('密码需要6~20位,由字母和数字组成，可以包含特殊符号“_”'));
							} else {
								callback();
							}
						},required: true, trigger: "blur"}],
					"passwordEnter": [{
						validator:(rule, value, callback) => {
							if (value === '') {
								callback(new Error('请再次输入密码'));
							} else if (value !== this.addUserform.password) {
								callback(new Error('两次输入密码不一致!'));
							} else {
								callback();
							}
						},required: true, trigger: "blur"}],
					// "telPhone": [{required: true, message: "请输入联系方式", trigger: "change"}],
					"companyChoose": [{required: true, message: "请选择企业", trigger: "change"}],
					"groupName": [{required: true, message: "请输入所属用户组", trigger: "blur"}],
				},
				editUserformRules:{
					"name": [{required: true, message: "请输入登录名", trigger: "change"}],
					"password": [{validator:(rule, value, callback) => {
							if (value != '' && !this.$utils.paswordReg(value)) {
								console.log('value',value)
								callback(new Error('密码需要6~20位,由字母和数字组成，可以包含特殊符号“_”'));
							} else {
								callback();
							}
						}, trigger: "blur"}],
					"passwordEnter": [{
						validator:(rule, value, callback) => {
							if (value !== this.addUserform.password) {
								callback(new Error('两次输入密码不一致!'));
							} else {
								callback();
							}
						}, trigger: "blur"}],
						
					// "telPhone": [{required: true, message: "请输入联系方式", trigger: "change"}],
					"companyChoose": [{required: true, message: "请选择企业", trigger: "change"}],
					"groupName": [{required: true, message: "请输入所属用户组", trigger: "change"}],
				},
				addUserform:{
					name:'',
					password:'',
					passwordEnter:'',
					groupId:'',
					groupName: '',
					realName:'',
					// otherName:'',
					telPhone:'',
					secretKey:'',
					sex:'',
					job:'',
					platformOsUserMemberNum:'',
					weChatId:'',
					onWork:"1",
					checkIp:'',
					ipWhiteList:'',
					headImageId:'',
					headImageUrl:'',
					systemMenuList:[],
					role:[],
					companyChoose:'',
					productCompanyId:'',
					
				},
				groupArr:[],
				isShowUserGrounpTree:false,//是否显示选择用户组弹框
				sex:[{
					label:'男',
					value:"1"
				},{
					label:'女',
					value:"0"
				}],
				jobArr:[],
				onWork:[{
					label:'有效',
					value:"1"
				},{
					label:'无效',
					value:"0"
				}],
				checkIp:[{
					label:'是',
					value:1
				},{
					label:'否',
					value:0
				}],
				roleList:[],
				systemMenuList:[],
				menuTreeProps:{
					label: 'title',
					children: 'children',
				}
			}
		},
		mounted() {
			// 获取用户信息
			if(this.$route.query.id){
				this.userId = this.$route.query.id;
				this.getSysUserInfo();
			}
			// 获取菜单树
			// this.getSysMenusTree();
			// // 获取用户组
			// this.getUserGroupList();
			// 获取职位
			this.getDict();
			// // 获取全部角色数据
			this.getAllRoleList();
		},
		methods:{
			/**
			 * 点击上传头像
			 */
			uploadHeaderImgFile(fileInfo) {
				console.log('fileInfo,index',fileInfo)
				let that = this;
				let file = fileInfo.file;
				//上传头像
				that.$loading();
				that.$uploadFileUtils.uploadFile(file, "image",true).then(res => {
					if(res) {
						// 保存图片
						this.saveImage(res,fileInfo.data,'contract')
					}
				})
			},
			/**
			 * 保存图片
			 * imgInfo:保存图片信息
			 * index：当前操作的索引值
			 * type：保存的是哪里的照片  headerImg：头像
			 */
			saveImage(imgInfo,index,type) {
				let that = this;
				that.$loading();
				that.$http.post(that.$api.saveImageApi, {
					"imageInfo": JSON.stringify(imgInfo),
					"flag": "userImage"  //上传的业务场景值
				}).then(res => {
					that.$loading().close();
					if(res.code == 200) {
						this.addUserform.headImageUrl = res.data.scaleUrl;
                        this.addUserform.headImageId = res.data.imageId;
					}
				})
			},
			/**
			 * 获取编辑用户信息
			 */
			getSysUserInfo(){
				this.$http.post(this.$api.userGetModelApi,{
					keyId:this.userId
				}).then(res=>{
					if(res.code == 200){
						this.addUserform.name = res.data.user.name;
						this.addUserform.realName = res.data.user.realName;
						// this.addUserform.otherName = res.data.user.otherName;
						this.addUserform.telPhone = res.data.user.telPhone;
						this.addUserform.platformOsUserMemberNum = res.data.user.platformOsUserMemberNum;
						this.addUserform.headImageId = res.data.user.headImageId;
						this.addUserform.headImageUrl = res.data.user.headImageUrl;
						this.addUserform.sex = res.data.user.sex;
						this.addUserform.job = res.data.user.job;
						this.addUserform.groupId = res.data.user.groupId;
						this.addUserform.groupName = res.data.user.groupName;
						this.addUserform.onWork = res.data.user.onWork.toString();
						this.addUserform.memberNum = res.data.user.memberNum;
						this.addUserform.weChatId = res.data.user.weChatId;
						this.addUserform.checkIp = res.data.user.checkIp;
						this.addUserform.ipWhiteList = res.data.user.ipWhiteList;
						this.addUserform.systemMenuList = res.data.user.menuIds;
						this.addUserform.companyChoose = res.data.user.companyChoose;
						this.addUserform.productCompanyId = res.data.user.productCompanyId;
						
						// this.addUserform.role = res.data.roleIds
					}
				})
			},
			/**
			 * 获取职位
			 */
			getDict(){
				this.$http.post(this.$api.getCommonDictsApi,{
					type:'工厂职位'
				}).then(res=>{
					console.log(res)
					if(res.code == 200){
						this.jobArr = res.data;
					}
				})
			},
			/**
			 * 获取全部角色数据
			 */
			getAllRoleList(){
				this.$http.post(this.$api.rolelistForUserApi,{keyId:this.userId}).then(res=>{
					if(res.code == 200){
						res.data.roles.forEach(item=>{
							if(item.checked){
								this.addUserform.role.push(item.value)
							}
						})
						this.roleList = res.data.roles;
					}
				})
			},
			/**
			 * 选择用户组
			 */
			selectUserGrounp(){
				this.isShowUserGrounpTree = true;
				setTimeout(()=>{
					this.$refs.dialogTree.setCurrentKey(this.addUserform.groupId || null)
				},500)
			},
			/**
			 * 选择用户组确认选择
			 */
			userGrounpTreeDialogConfirm(){
				let treeVal = this.$refs.dialogTree.getCurrentNode();
				this.addUserform.groupId = treeVal.key || '';
				this.addUserform.groupName = treeVal.title || '';
				this.isShowUserGrounpTree = false;
			},
			/**
			 * 清除选择用户组
			 */
			userGrounpTreeDialogClear(){
				this.addUserform.groupId = '';
				this.addUserform.groupName = '';
				this.isShowUserGrounpTree = false;
			},
			/**
			 * 关闭选择用户组
			 */
			userGrounpTreeDialogClose(){
				this.isShowUserGrounpTree = false;
			},
			/**
			 * 点击生成密钥
			 */
			// userKeyFun(){
			// 	this.$http.post(this.$api.generateUUidDataApi).then(res=>{
			// 		if(res.code == 200){
			// 			this.addUserform.secretKey = res.data;
			// 			console.log(res,this.addUserform)
			// 		}
			// 	})
			//
			// },
			/**
			 * 输入内容自动查询搜索结果输入框
			 * @param {Object} queryStr
			 * @param {Object} callback
			 */
			// querySearch(queryStr, callback) {
			// 	let that = this;
			// 	let result = [];
			// 	let param = {};
			// 	that.$http.post(that.$api.getProductCompanyForAutocompleteApi, {
			// 		"keyword": queryStr
			// 	}).then(res => {
			// 		if (res.code == 200) {
			// 			if(!this.$utils.isEmpty(res.data)){
			// 				res.data.forEach(item=>{
			// 					result.push(item);
			// 					callback(result);
			// 				})
			// 			}else{
			// 				callback([]);
			// 			}
			// 		}
			// 	})
			// },
			/**
			 * 选择上搜索项
			 */
			handleInputSelect(e){
				console.log('e',e,this.addAppFrom)
				this.addUserform.companyChoose = e.label;
				this.addUserform.productCompanyId = e.id || '';
			},
			/**
			 * 提交
			 */
			saveForm(){
				let that = this;
				that.$refs["addUserformForm"].validate(valid => {
					if(valid) {
						console.log('this.addUserform',this.addUserform)
						if(this.$utils.isEmpty(this.userId)){
							this.$http.post(this.$api.userEditApi,{
								name:this.addUserform.name,
								perpwd:this.$utils.rsa(this.addUserform.password,this.$api.pubk),
								realName:this.addUserform.realName,
								// otherName:this.addUserform.otherName,
								telPhone:this.addUserform.telPhone,
								platformOsUserMemberNum:this.addUserform.platformOsUserMemberNum,
								headImageId:this.addUserform.headImageId,
								headImageUrl:this.addUserform.headImageUrl,
								sex:this.addUserform.sex,
								job:this.addUserform.job,
								groupId:this.addUserform.groupId,
								onWork:this.addUserform.onWork,
								memberNum:this.addUserform.memberNum,
								weChatId:this.addUserform.weChatId,
								checkIp:this.addUserform.checkIp,
								ipWhiteList:this.addUserform.ipWhiteList,
								// ownerMenuIds:this.$refs.systemMenu.getCheckedKeys().toString(),
								ownerRoleIds:this.addUserform.role.toString(),
								companyChoose:this.addUserform.companyChoose,
								productCompanyId:this.addUserform.productCompanyId
							}).then(res=>{
								if(res.code == 200){
									this.$confirm('', '操作成功！', {
										confirmButtonText: '确定',
										type: 'success',
										center:true,
										showClose:false,
										showCancelButton:false,
									}).then(() => {
										window.close();
										//刷新列表
										window.opener.getSysUserList();
									}).catch(() => {
									
									});
									// this.$message.success('操作成功！')
									// setTimeout(()=>{
									// 	window.close();
									// 	//刷新列表
									// 	window.opener.getSysUserList();
									// },1000)
								}
							})
						}else{
							let param = {
								id:this.userId,
								name:this.addUserform.name,
								realName:this.addUserform.realName,
								// otherName:this.addUserform.otherName,
								telPhone:this.addUserform.telPhone,
								platformOsUserMemberNum:this.addUserform.platformOsUserMemberNum,
								headImageId:this.addUserform.headImageId,
								headImageUrl:this.addUserform.headImageUrl,
								sex:this.addUserform.sex,
								job:this.addUserform.job,
								// groupId:this.addUserform.groupId,
								onWork:this.addUserform.onWork,
								checkIp:this.addUserform.checkIp,
								ipWhiteList:this.addUserform.ipWhiteList,
								// ownerMenuIds:this.$refs.systemMenu.getCheckedKeys().toString(),
								ownerRoleIds:this.addUserform.role.toString(),
								companyChoose:this.addUserform.companyChoose,
								productCompanyId:this.addUserform.productCompanyId
							}
							if(!this.$utils.isEmpty(this.addUserform.password)){
								param.perpwd = this.$utils.rsa(this.addUserform.password,this.$api.pubk);
							}
							this.$http.post(this.$api.userEditApi,param).then(res=>{
								if(res.code == 200){
									this.$confirm('', '操作成功', {
										confirmButtonText: '确定',
										type: 'success',
										center:true,
										showClose:false,
										showCancelButton:false,
									}).then(() => {
										window.close();
										//刷新列表
										window.opener.getSysUserList();
									}).catch(() => {
									
									});
									
								}
							})
						}
						
					}else{
						this.$message('请输入必填项')
					}
				})
			}
		}
	}
</script>

<style scoped>
	.containerMain{
		padding-bottom: 140px;
		min-height: 100%;
		box-sizing: border-box;
		position: relative;
	}
	/* 表单样式 */
	.containerInfoItem{
		border: 1px solid #F2F6FC;
		margin-bottom: 20px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.containerInfoItemFont{
		font-size: 14px;
		color: #5C7085;
		margin-top: 10px;
	}
	.elFormItemBox{
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		width: 25%;
		padding: 0 20px;
		box-sizing: border-box;
		min-width: 200px;
	}
	
	/* 底部按钮 */
	.footerEnterBtn {
		position: absolute;
		bottom: 40px;
		width: 100%;
		left: 0;
	}
	
	.footerEnterBtn .el-button {
		margin: 0 15px;
	}
	/* 选择用户组弹框树 */
	.dialogForm{
		height: 200px;
		overflow-y: scroll;
	}
</style>
<style>
	/* 设置表单内容充满 */
	.containerInfoItem .el-form-item__content,
	.containerInfoItem .el-form-item__content .el-select,
	.containerInfoItem .el-date-editor.el-input{
		width: 100%;
	}
	/* 上传照片 */
	.containerInfoItem .avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
		height: 108px;
		width: 108px;
	}
	.containerInfoItem .avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	.containerInfoItem .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 38px;
	    height: 38px;
	    line-height: 38px;
	    text-align: center;
	}
	.containerInfoItem .avatar {
	    width: 108px;
	    height: 108px;
	    display: block;
	}
</style>
